import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-map-legend',
  templateUrl: './map-legend.component.html',
  styleUrls: ['./map-legend.component.css']
})
export class MapLegendComponent implements OnInit, OnDestroy {

	layerCate: string;

	showLegend: boolean;

	private mapLegendSub: Subscription;
	private selectedLayerSub: Subscription;
	constructor(
		private activityService: ActivityService,
		private mapService: MainDataMapService
	) { }

	ngOnInit() {
		this.mapLegendSub = this.mapService.mapLegendBS.subscribe(data => {
			this.showLegend = data.show;
		});
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			let cate = null;
			if (data && data.layer && data.layer.category) {
				cate = data.layer.category.code;
			}
			this.layerCate = cate;
		});
	}
	ngOnDestroy(): void {
		this.selectedLayerSub.unsubscribe();
		this.mapLegendSub.unsubscribe();
	}

}
